import ConfirmDialog from "@/components/ConfirmDialog";

export const MiningConfirmDialog = ({ confirm, busy, onClose }) => {
  if (!confirm) return null;

  return (
    <ConfirmDialog
      state={{
        title: confirm.title,
        message: confirm.message,
        confirmLabel: confirm.confirmLabel,
        onConfirm: async () => {
          await confirm.onConfirm();
        },
      }}
      busy={busy}
      onClose={onClose}
    />
  );
};